import CustomBreadCrumb from '../../../constants/CustomBreadCrumb'
import CustomCard from '../../../constants/CustomCard'


const FinanceReportsPage = () => {
const items = [
  {
    title: 'TRIAL BALANCE',
    to: '/trial-balance-report',
    linkName: 'Finance Reports'
  },
  {
    title: 'ACCOUNTS PAYABLE',
    to: '/accounts-payable-report',
    linkName: 'ACCOUNTS PAYABLE'
  },
  {
    title: 'ACCOUNTS RECEIVABLE',
    to: '/accounts-receivable-report',
    linkName: 'ACCOUNTS RECEIVABLE'
  },
  {
    title: 'FIXED ASSETS',
    to: '/fixed-assets-report',
    linkName: 'FIXED ASSETS'
  }
]
  return (
    <>
      <CustomBreadCrumb title={'Finance Reports'} isReport={false} isDashboard={false}/>
      <div className="row mt-5 g-8">
          {
            items.map((item, index) => (
              <div key={index} className='col-xl-3'>
                <CustomCard url={item?.to} title={item?.title} />
              </div>
              )
            )
          }
      </div>
    </>
  );
}

export default FinanceReportsPage;